import { parseAmount, USD } from "@loot-os/api-contract";
import {
  MAX_PAID_COST_CENTS,
  MIN_PAID_COST_CENTS,
} from "@loot-os/fulfillment-core/order/constants";
import type { LinePaidCost } from "@loot-os/fulfillment-core/order/stockx-size-refund";

/**
 * One paid cost per StockX line from the dollar amounts typed so far, or null while any line is
 * missing one. The transition refuses a move to PROCESSING without every one (ENG-7343), so the
 * form asks for them first. An amount outside what the transition accepts (0, or past the
 * `integer` column's top) counts as missing.
 */
export function buildPaidCosts(
  stockxLineIds: readonly string[],
  dollarsByLineId: Readonly<Record<string, string>>,
): LinePaidCost[] | null {
  const paidCosts: LinePaidCost[] = [];
  for (const lineId of stockxLineIds) {
    const paidCostCents = parseAmount(dollarsByLineId[lineId] ?? "", USD);
    if (
      paidCostCents === null ||
      paidCostCents < MIN_PAID_COST_CENTS ||
      paidCostCents > MAX_PAID_COST_CENTS
    ) {
      return null;
    }
    paidCosts.push({ lineId, paidCostCents });
  }
  return paidCosts;
}
